import { format, fromUnixTime, isValid, parse } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';

export const timestampToDate = (timestampDate: number) => new Date(timestampDate);

export const fromUnixSecondsToDate = (seconds: number) => fromUnixTime(seconds);

export function formatDate(date: Date, mask: string = 'dd MMM yyyy', isRtl = false) {
  return format(date, mask, { locale: isRtl ? ar : enUS });
}

export function dateToTimestamp(date: Date): number {
  const timestamp = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 7, 0, 0);
  return Math.floor(timestamp / 1000);
}

export const dateToUnixTimestamp = (date: Date): number => Math.floor(date.getTime() / 1000);

export function getDaysRemaining(milliseconds: number) {
  const now = new Date().getTime();
  const timeDifference = milliseconds - now;

  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
}

export function addYearsToDate(years: number, fromDate = new Date()): Date {
  const result = new Date(fromDate);
  result.setFullYear(result.getFullYear() + years);
  return result;
}

export function parseDateString(dateStr: string): Date | null {
  if (!dateStr) {
    return null;
  }

  const format = 'dd/MM/yyyy';
  const parsedDate = parse(dateStr, format, new Date());

  return isValid(parsedDate) ? parsedDate : null;
}

export function formatDateToDDMMYYYY(date: Date) {
  return formatDate(date, 'dd.MM.yyyy');
}

export function calculateAge(dateOfBirth: Date) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }

  return age;
}

export function resetTime(initialDate: Date | number): Date {
  const date = new Date(initialDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
// TODO: should be in app or feature layers
export const MASK_FOR_ANALYTICS = 'yyyy-MM-dd';
